import {inject, InjectionToken} from '@angular/core';
import {WINDOW} from './window';

export const NAVIGATOR = new InjectionToken<Navigator>(
  'window.navigator object',
  {
    factory: (): Navigator => inject(WINDOW).navigator,
  },
);
